<template>
	<v-skeleton-loader v-if="skeleton" type="article,list-item,list-item,list-item"></v-skeleton-loader>
	<v-card v-else v-bind="$attrs" v-on="$listeners">
		<div class="d-flex flex-no-wrap justify-space-between align-center">
			<v-avatar class="ma-3" size="125" color="secondaryLight" style="flex: 0">
				<v-img :src="value.data.image"></v-img>
			</v-avatar>

			<div style="flex: 1">
				<v-card-subtitle class="overline text--disabled py-0 mb-n1" v-text="fullView ? $t('accountCard.myProfile') : $t('accountCard.account')"></v-card-subtitle>
				<v-card-title
					class="text-h5 align-start pt-0 pb-4"
					style="justify-content: start !important"
					v-text="value.data.firstname"
				>
				</v-card-title>
				<v-card-subtitle class="font-italic" v-text="value.data.firstname + ' ' + value.data.lastname"></v-card-subtitle>
			</div>

			<v-btn v-if="fullView" color="secondaryDark" class="mr-4" :to="routeEdit" large icon>
				<v-icon>mdi-pencil</v-icon>
			</v-btn>
		</div>

		<v-card-text>
			<v-divider class="mb-4" />

			<v-list-item :key="itemIdx" v-for="(item, itemIdx) in items" dense>
				<v-list-item-icon>
					<v-icon color="secondaryDark" v-text="item.icon"></v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<a v-if="item.href" :href="item.href">
						<span v-text="item.text"></span>
					</a>
					<span v-else v-text="item.text"></span>
				</v-list-item-content>
			</v-list-item>

			<v-list-item v-if="fullView" class="justify-end">
				<v-list-item-action-text>
					<router-link class="text-decoration-none d-flex align-center" :to="routeEdit">
						<span v-text="$t('accountCard.edit')"></span>
						<v-icon right x-small>mdi-arrow-right</v-icon>
					</router-link>
				</v-list-item-action-text>
			</v-list-item>
		</v-card-text>
	</v-card>
</template>

<script>
import { AccountModel } from '@connectngo/sdk';

export default {
	name: 'AccountCard',

	props: {
		value: {
			type: AccountModel,
			default: () => new AccountModel(),
		},
		skeleton: {
			type: Boolean,
			default: false,
		},
		fullView: {
			type: Boolean,
			default: true,
		},
		routeEdit: {
			type: Object,
			default: () => ({ name: 'account_section', params: { section: 'edit' } }),
		},
	},

	methods: {
		getItems() {
			return [
				{ icon: 'mdi-email-outline', text: this.value.data.email, href: 'mailto:' + this.value.data.email },
				{ icon: 'mdi-home-outline', text: this.$t('accountCard.address', {
					address: [
						this.value.data.address.address1,
						this.value.data.address.address2,
						this.value.data.address.city,
						this.value.data.address.country,
						this.value.data.address.state_province_region,
						this.value.data.address.zipcode_postalcode,
					].filter(item => item !== null).join(', ') || this.$i18n.t('accountCard.none'),
				}) },
			];
		},
	},

	watch: {
		value: {
			deep: true,
			immediate: true,
			handler() {
				this.items = this.getItems();
			},
		},
	},
}
</script>
